export default async (taskId) => {
    const result = app.fetch(`${app.root}ajax/task_price_load.php`, { id_task: taskId });

    return result;
};
